import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { QUERY_URL_PARAM } from "@/components/Search/constants";
import { useInstantSearch } from "react-instantsearch";
import { FilterVersion } from "@/components/Search/types";
import { useSearchIndex } from "@/components/Search/components/SearchContextProvider";
interface SearchResultCountProps {
  resultsTitle?: string;
  filterVersion: FilterVersion;
}
function SearchResultCount({
  resultsTitle,
  filterVersion,
}: SearchResultCountProps) {
  const searchParams = useSearchParams();
  const { status, scopedResults } = useInstantSearch();
  const { searchIndex } = useSearchIndex();
  const queryParam = searchParams.get(QUERY_URL_PARAM);
  const queryResultsLabel = resultsTitle ? resultsTitle : queryParam;
  const [numberOfHits, setNumberOfHits] = useState<number>(0);

  useEffect(() => {
    const totalHits = scopedResults.reduce((sum, { indexId, results }) => {
      if (indexId === searchIndex) return sum;
      return sum + (results?._rawResults[0]?.nbHits || 0);
    }, 0);

    setNumberOfHits(totalHits);
  }, [scopedResults, searchIndex]);

  const containerClassName =
    filterVersion === FilterVersion.VerticalFilterV2 ? "mb-4" : "";
  return (
    <div className={status !== "idle" ? "invisible" : ""}>
      <h2 className={`text-2xl ${containerClassName}`}>
        {numberOfHits} results{" "}
        {queryResultsLabel ? `for "${queryResultsLabel}"` : null}
      </h2>
    </div>
  );
}

export default SearchResultCount;
